<!--<div style="margin-bottom: 1%">-->
<!--  <app-chartjs [data]="tempData | async" [id]="'temp'"></app-chartjs>-->
<!--</div>-->

<app-grouped-charts [data]="data"></app-grouped-charts>
